<template>
  <div id="app">
    <Layout />
  </div>
</template>
<script>
import Layout from "@/components/layout";
import sideMenu from "@/components/sideMenu";
export default {
  name: "Index",
  components: {
    Layout,
    sideMenu,
  },
};
</script>
<style lang="scss">
:root,
body {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}
#app {
  padding: 72px 0 0 0;
}
</style>